import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { GameSelection } from '../../../models/game-selection.model';

import { TableBaseComponent } from '../table-base/table-base.component';

import { UserService } from '../../../../core/services/user.service';
import { ConfigurationService } from '../../../services/configuration.service';

@Component({
  selector: 'app-game-selection-table',
  templateUrl: './game-selection-table.component.html'
})
export class GameSelectionTableComponent extends TableBaseComponent<GameSelection> {

  @Input() detailLink = '/levels';
  @Output() readonly selected: EventEmitter<GameSelection> = new EventEmitter<GameSelection>();

  tableConfig: any = this.getTableConfig('level');

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected config: ConfigurationService,
    protected userService: UserService
  ) {
    super(router, route, config, userService);
  }

  getGlobalFilterFields() {
    this.globalFilters = this.globalFilters || [ {
      label: 'ID',
      field: 'id',
      active: this.showId
    }, {
      label: 'Name',
      field: 'name.value',
      active: true
    } ];

    return this.globalFilters
      .filter(filter => filter.active)
      .map(filter => filter.field);
  }

  handleRowReorder(): void {
    this.data.forEach((item, i) => item.sortOrder = i);

    super.handleRowReorder();
  }
}
